import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
	selector: 'app-google-action-button',
	templateUrl: './google-action-button.component.html',
	styleUrls: ['./google-action-button.component.scss']
})
export class GoogleActionButtonComponent {

	@Input() bWorking = false;
	@Input() ariaLabel! : string;
	@Output() eeClick = new EventEmitter<void>();
}
